export default {
      id: "plus-usage",
      viewBox: "0 0 19.665 18.54",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#plus",
      toString: function () {
        return this.url;
      }
    }